import { __awaiter } from "tslib";
import { TablePropertiesLeafElementDestination } from './table-properties-leaf-element-destination';
export class TableOverlapDestination extends TablePropertiesLeafElementDestination {
    processElementOpen(_reader) {
        return __awaiter(this, void 0, void 0, function* () {
        });
    }
}
